import React from 'react'

// #4c4c4b is $dark-accent-gray in scss
// className color overrides color param
const CheckmarkIcon = ({ size = 24, color = 'white', className = '' }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M24 4.685l-16.327 17.315-7.673-9.054.761-.648 6.95 8.203 15.561-16.501.728.685z" />
    </svg>
  )
}

export default CheckmarkIcon
